import queryString from 'query-string';
import { addObjectToFormData } from 'Shared/helpers';

import { directUpload } from 'Shared/utils/FileUpload.utils';
import instance from './instance';

export function fetchFeedbacks(query) {
  return instance.get(queryString.stringifyUrl({ url: '/feedbacks', query }));
}

export function fetchAvailableFeedbackTemplatesForExport() {
  return instance.get('/feedbacks/available_templates_for_export');
}

export function fetchFeedbacksForExport(query) {
  return instance.get(queryString.stringifyUrl({ url: '/feedbacks/export', query }));
}

export function fetchFeedbackDrafts(query) {
  return instance.get(queryString.stringifyUrl({ url: '/feedbacks/drafts', query }));
}

export function fetchSingleFeedback(uuid) {
  return instance.get(`/feedbacks/${uuid}`);
}

export const createFeedback = async ({
  feedbackRecognitionRequestId,
  uuid,
  creatorId,
  receiverId,
  workspaceId,
  requestType,
  likeThatText,
  likeThatVideo,
  wishThatText,
  answers,
  reviewTemplateSlug,
  isPublic = false,
  shareOnChatData = null,
  wishThatVideo,
  gifUrl,
  template_type,
  isDraft = false,
  isFeedbackRequested = false,
  userSuggestionId,
}) => {
  const data = new FormData();
  if (feedbackRecognitionRequestId) data.append('feedback[feedbackRecognitionRequestId]', feedbackRecognitionRequestId);
  data.append('feedback[uuid]', uuid);
  data.append('feedback[creatorId]', creatorId);
  data.append('feedback[requestType]', requestType);
  if (receiverId) data.append('feedback[receiverId]', receiverId);
  data.append('feedback[isPublic]', isPublic);
  data.append('feedback[is_draft]', isDraft);
  if (isFeedbackRequested) data.append('isFeedbackRequested', isFeedbackRequested);
  data.append('feedback[workspaceId]', workspaceId);
  if (likeThatText) data.append('feedback[likeThatText]', likeThatText);
  if (wishThatText) data.append('feedback[wishThatText]', wishThatText);
  if (gifUrl) data.append('feedback[gif_url]', gifUrl);
  if (template_type) data.append('feedback[template_type]', template_type);
  if (likeThatVideo) {
    const blob = await directUpload(likeThatVideo.file);
    data.append('feedback[likeThatVideo][video_attributes][webm_file]', blob.signed_id);
    data.append('feedback[likeThatVideo][video_attributes][audio_only]', likeThatVideo.audioOnly);
  }
  if (wishThatVideo) {
    const blob = await directUpload(wishThatVideo.file);
    data.append('feedback[wishThatVideo][video_attributes][webm_file]', blob.signed_id);
    data.append('feedback[wishThatVideo][video_attributes][audio_only]', wishThatVideo.audioOnly);
  }
  if (answers) addObjectToFormData(data, answers, 'feedback[answers]');
  if (reviewTemplateSlug) data.append('feedback[reviewTemplateSlug]', reviewTemplateSlug);
  if (shareOnChatData && shareOnChatData.shareToChat) {
    data.append('feedback[shareOnChatData][notificationDestination]', shareOnChatData.shareToChat);
    data.append('feedback[shareOnChatData][channel]', shareOnChatData.channel);
  }
  if (userSuggestionId) {
    data.append('user_suggestion_id', userSuggestionId);
  }
  return instance.postForm('/feedbacks', data);
};

export const updateFeedback = ({
  uuid,
  likeThatText,
  likeThatVideo,
  wishThatText,
  wishThatVideo,
  answers,
  gifUrl,
  isDraft,
  isFeedbackRequested,
  userSuggestionId,
}) => {
  const data = new FormData();
  if (likeThatText) data.append('feedback[likeThatText]', likeThatText);
  if (wishThatText) data.append('feedback[wishThatText]', wishThatText);
  if (gifUrl) data.append('feedback[gif_url]', gifUrl);
  data.append('feedback[is_draft]', isDraft);
  if (isFeedbackRequested) data.append('isFeedbackRequested', isFeedbackRequested);
  if (likeThatVideo && likeThatVideo.file) {
    data.append('feedback[likeThatVideo][video_attributes][webm_file]', likeThatVideo.file);
    data.append('feedback[likeThatVideo][video_attributes][audio_only]', likeThatVideo.audioOnly);
  }
  if (wishThatVideo && wishThatVideo.file) {
    data.append('feedback[wishThatVideo][video_attributes][webm_file]', wishThatVideo.file);
    data.append('feedback[wishThatVideo][video_attributes][audio_only]', wishThatVideo.audioOnly);
  }
  if (likeThatVideo && likeThatVideo._destroy) {
    data.append('feedback[destroyLikeThatVideo]', true);
  }
  if (wishThatVideo && wishThatVideo._destroy) {
    data.append('feedback[destroyWishThatVideo]', true);
  }
  if (answers) addObjectToFormData(data, answers, 'feedback[answers]');
  if (userSuggestionId) {
    data.append('user_suggestion_id', userSuggestionId);
  }
  return instance.putForm(`/feedbacks/${uuid}`, data);
};

export function destroyFeedback(uuid) {
  return instance.delete(`/feedbacks/${uuid}`);
}

export const viewFeedback = ({ uuid }) => instance.post(`/feedbacks/${uuid}/feedback_viewed`, { feedback: { uuid } });

export const fetchAIFeedbackSuggestions = data => instance.post('/feedbacks/create_ai_feedback_suggestions', data);
